<template>
  <v-container>
    <v-col cols="6" class="mx-auto">
      <locale-select @change="fireLocaleChange" />
    </v-col>
    <form-wrapper :validator="$v.form">
      <v-form @submit.prevent="handleSubmit">
        <v-row>
          <v-col cols="12">
            <form-group
              name="contacts_address"
              attribute="fields.contacts_address"
            >
              <v-textarea
                slot-scope="{ attrs, listeners }"
                v-bind="attrs"
                v-on="listeners"
                outlined
                no-resize
                v-model="form.contacts_address"
              >
              </v-textarea>
            </form-group>
          </v-col>
          <v-col cols="6">
            <form-group name="contacts_phone">
              <v-text-field
                slot-scope="{ attrs, listeners }"
                v-bind="attrs"
                v-on="listeners"
                outlined
                v-model="form.contacts_phone"
              ></v-text-field>
            </form-group>
          </v-col>
          <v-col cols="6">
            <form-group name="contacts_email" attribute="contacts_email">
              <v-text-field
                slot-scope="{ attrs, listeners }"
                v-bind="attrs"
                v-on="listeners"
                outlined
                v-model="form.contacts_email"
              ></v-text-field>
            </form-group>
          </v-col>
          <v-col cols="12">
            <v-btn
              :loading="loadingBtn"
              class="primary"
              large
              block
              type="submit"
              :disabled="$v.form.$invalid"
              >{{ $t("button.save") }}</v-btn
            >
          </v-col>
        </v-row>
      </v-form>
    </form-wrapper>
  </v-container>
</template>

<script>
import { email, minLength, maxLength } from "vuelidate/lib/validators";

import { StoreData } from "@/helpers/apiMethods";
import { validPhoneNumber } from "@/utils/validate.js";

export default {
  name: "ContactComponent",
  props: {
    settings: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      form: {
        contacts_phone: "",
        contacts_address: "",
        contacts_email: ""
      },
      loadingBtn: false,
      locale: this.locale
    };
  },
  methods: {
    fireLocaleChange(locale) {
      this.locale = locale;
    },
    handleSubmit() {
      const formData = {
        ...this.form,
        locale: this.locale
      };
      this.loadingBtn = true;
      StoreData({ reqName: "settings", data: formData })
        .then(res => {
          console.log(res);
        })
        .catch(err => console.log(err))
        .finally(() => (this.loadingBtn = false));
    }
  },
  validations() {
    return {
      form: {
        contacts_phone: {
          validPhoneNumber
        },
        contacts_email: {
          email
        },
        contacts_address: {
          minLength: minLength(3),
          maxLength: maxLength(100)
        }
      }
    };
  },
  watch: {
    settings: {
      handler(settings) {
        if (settings) {
          console.log(settings);
          Object.keys(this.form).map(key => {
            setTimeout(() => {
              this.form[key] = settings[key];
            }, 1000);
          });
        }
      },
      immediate: true
    }
  }
};
</script>
